export function annotateResult(result: $TSFixMe) {
  return result.map((entry: $TSFixMe) => {
    entry.matches.map((match: $TSFixMe) => {
      if (match.key.includes("attachments.")) {
        entry.item.attachments.map((attachment: $TSFixMe, i: $TSFixMe) => {
          if (i === match.refIndex) {
            // eslint-disable-next-line no-param-reassign
            attachment.match = match;
          }
          return attachment;
        });
      } else {
        // eslint-disable-next-line no-param-reassign
        entry.item.match = match;
      }
      return match;
    });
    return entry;
  });
}

export function extractItems(list: $TSFixMe) {
  return list.map((entry: $TSFixMe) => {
    const { item } = entry;
    item.collapsed = false;
    return item;
  });
}
